import React from "react"
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react"
// Import Swiper styles
import "swiper/css"
import "swiper/css/effect-fade"
import "swiper/css/navigation"
import "swiper/css/pagination"

import "./styles.css"

// import required modules
import { Autoplay, EffectFade, Navigation, Pagination } from "swiper/modules"

// image start
import slider_default1 from "../assets/slider-default1.jpg"
import slider_default2 from "../assets/slider-default2.jpg"
import slider_default3 from "../assets/slider-default3.jpg"
// image end

const slideDetails = [
    { title: "KINDERGARTEN PROGRAM", heading: "Best Children’s Education", img: `${slider_default1}` },
    { title: "FRIENDLY ATMOSPHARE", heading: "Learning is an Adventure", img: `${slider_default2}` },
    { title: "WHERE FUN HAPPENS!", heading: "Kindergarten & Baby Care", img: `${slider_default3}` },
]

const Slider = () => {
    return (
        <div>
            <div className="w-full h-auto">
                <Swiper
                    spaceBetween={30}
                    effect={"fade"}
                    loop={true}
                    // navigation={true}
                    // pagination={{
                    // clickable: true,
                    // }}
                    autoplay={{
                        delay: 2500,
                        disableOnInteraction: false,
                    }}
                    modules={[Autoplay, EffectFade, Navigation, Pagination]}
                    className="mySwiper relative">
                    {/* <SwiperSlide>
                        <img src={slider_default1} alt="" />
                        <h2 className='absolute top-52 left-[50px] text-[25px] text-white z-10'>Hello this is neeraj</h2>
                    </SwiperSlide>
                  */}
                    {slideDetails &&
                        slideDetails.map((item, index) => {
                            return (
                                <>
                                    <SwiperSlide>
                                        <img src={item.img} alt="" />
                                        <p className="absolute top-[42%] -translate-y-[42%] left-[210px] text-[20px] text-white z-10">{item.title}</p>
                                        <h2 className="absolute top-[55%] -translate-y-[50%] left-[210px] text-[60px] text-white z-10 font-extrabold w-[500px] leading-tight text-start">{item.heading}</h2>
                                    </SwiperSlide>
                                </>
                            )
                        })}
                </Swiper>
            </div>
        </div>
    )
}

export default Slider

// import React from 'react'
// import Carousel from 'react-bootstrap/Carousel';

// // // image start
// import slider_default1 from "../assets/slider-default1.jpg"
// import slider_default2 from "../assets/slider-default2.jpg"
// import slider_default3 from "../assets/slider-default3.jpg"
// // // image end

// const Slider = () => {
//     return (
//         <div className='w-full'>
//             <Carousel fade>
//                 <Carousel.Item>
//                     {/* <ExampleCarouselImage text="First slide" /> */}
//                     <img src={slider_default1} alt="" />
//                     <Carousel.Caption>
//                         <h3>First slide label</h3>
//                         <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
//                     </Carousel.Caption>
//                 </Carousel.Item>
//                 <Carousel.Item>
//                     <img src={slider_default2} alt="" />

//                     <Carousel.Caption>
//                         <h3>Second slide label</h3>
//                         <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
//                     </Carousel.Caption>
//                 </Carousel.Item>

//             </Carousel>
//         </div>
//     )
// }

// export default Slider
